export default __webpack_public_path__ + "images/angle-left-faded_1b45bab484dabf5ef3cc4288c362656a.svg";